import { signInWithPopup, signOut } from "firebase/auth";
import { types } from "../types/types";
import { auth, googleProvider } from "../../firebase/config";
import Swal from "sweetalert2";

export const startGoogleLogin = () => {
  return async (dispatch) => {
    const { user } = await signInWithPopup(auth, googleProvider);
    if (user.email.includes("@auta") || user.email.includes("@kardur")) {
      dispatch(login(user.uid, user.displayName, user.email, true));
    } else {
      await signOut(auth);
      Swal.fire(
        "Acceso restringido.",
        "Solo los usuarios de Auta pueden acceder.",
        "error"
      );
    }
  };
};

export const login = (uid, displayName, email, isAuthenticated) => ({
  type: types.login,
  payload: {
    uid,
    displayName,
    email,
    isAuthenticated,
  },
});

export const startLogout = (dispatch, navigate) => {
  signOut(auth);
  dispatch(logout(false));
  navigate("/login");
};

export const logout = (isAuthenticated) => ({
  type: types.logout,
  payload: {
    isAuthenticated,
  },
});
